import * as yup from 'yup'

const schema = (largeScale) =>
  yup.object().shape({
    answers: yup.array().of(
      yup.object().shape({
        answer: yup
          .mixed()
          .test(
            'within-range',
            'Resposta precisa estar dentro do intervalo especificado para a classificação selecionada.',
            function (value) {
              // Extract the index from the path (answers[<index>].answer)
              const path = this.path || ''
              const m = /answers\[(\d+)\]/.exec(path)
              const idx = m ? Number(m[1]) : 0

              const item = largeScale?.[idx] || {}
              const classificationRanges = item?.classificationRanges || []
              const selectedRangeId =
                this.parent?.range || this.parent?.classificationRange
              const range = classificationRanges.find(
                (r) => Number(r.id) === Number(selectedRangeId),
              )

              const minInput = range?.minInputValue
              const maxInput = range?.maxInputValue

              // `answer` must be present (non-empty)
              if (value == null || value === '') return false

              // if there are no numeric constraints, any non-empty value is valid
              if (minInput == null && maxInput == null) return true

              const num = Number(value)
              if (Number.isNaN(num)) return false

              return (
                (minInput == null || minInput <= num) &&
                (maxInput == null || num <= maxInput)
              )
            },
          )
          .required(),
        range: yup.string().required('Escolha uma classificação'),
      }),
    ),
  })

export default schema
